import { render, staticRenderFns } from "./FallRadarList.vue?vue&type=template&id=1a60b544&scoped=true"
import script from "./FallRadarList.vue?vue&type=script&lang=js"
export * from "./FallRadarList.vue?vue&type=script&lang=js"
import style0 from "./FallRadarList.vue?vue&type=style&index=0&id=1a60b544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a60b544",
  null
  
)

export default component.exports